import { render } from "./Meny.vue?vue&type=template&id=2c40029a&scoped=true"
import script from "./Meny.vue?vue&type=script&lang=js"
export * from "./Meny.vue?vue&type=script&lang=js"

import "./Meny.vue?vue&type=style&index=0&id=2c40029a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c40029a"]])

export default __exports__